import React from "react";

function DiscussionsOfRegisterDocument() {
  return <div>Disucssions</div>;
}

export default DiscussionsOfRegisterDocument;
